import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export const MirrorInput = ({
  targetFieldName,
  sourceFieldName,
  children
}: {
  sourceFieldName: string
  targetFieldName: string
  children: JSX.Element
}) => {
  const { watch, setValue, trigger } = useFormContext()
  const sourceFieldValue = watch(sourceFieldName)

  useEffect(() => {
    setValue(targetFieldName, sourceFieldValue)
    if (sourceFieldValue) {
      trigger(targetFieldName)
    }
  }, [sourceFieldValue, targetFieldName, setValue, trigger])

  return children
}
